import { SubscriptionCFA } from '@/account/types/subscription';

export default function shouldHideCreditModal(
  subscription: SubscriptionCFA | undefined
): boolean {
  return (
    !!subscription &&
    (subscription.upcoming_pickup !== undefined ||
      subscription.has_vehicle ||
      subscription.can_return ||
      subscription.can_swap)
  );
}
